import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustCards from './components/TrustCards';
import TasksSolved from './components/TasksSolved';
import WhenNeeded from './components/WhenNeeded';
import WhyTrainingsFail from './components/WhyTrainingsFail';
import WhyEmployeesDontSell from './components/WhyEmployeesDontSell';
import ProgramIncludes from './components/ProgramIncludes';
import SkillsLearned from './components/SkillsLearned';
import HowTrainingGoes from './components/HowTrainingGoes';
import CaseStudy from './components/CaseStudy';
import Results from './components/Results';
import Formats from './components/Formats';
import WhyAlexeySivko from './components/WhyAlexeySivko';
import SuitableCompanies from './components/SuitableCompanies';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Программа', target: 'program' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function SalesTrainingSeoPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по продажам | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <TrustCards />
        <TasksSolved />
        <WhenNeeded />
        <WhyTrainingsFail />
        <WhyEmployeesDontSell />
        <ProgramIncludes />
        <SkillsLearned />
        <HowTrainingGoes />
        <CaseStudy />
        <Results />
        <Formats />
        <WhyAlexeySivko />
        <SuitableCompanies />
        <FAQSection />
        <CTASection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}